import { type ErrorHandler, inject, Injectable } from '@angular/core';
import { AppErrorService } from '@core/error-handling/app-error.service';
import { isAppError } from '@core/error-handling/app-error.types';
import { AppErrorMapperService } from '@core/error-handling/app-error-mapper.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly appErrorMapper = inject(AppErrorMapperService);
  private readonly appErrorService = inject(AppErrorService);

  public handleError(error: unknown): void {
    if (isAppError(error)) {
      if (error.source !== 'runtime') {
        return;
      }

      this.appErrorService.reportFatal(error);
      return;
    }

    this.appErrorService.reportFatal(this.appErrorMapper.fromRuntimeError(error));
  }
}
